// vue
import { createApp } from "vue";
import router from "./router";

// plugins
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";
import { VueQueryPlugin } from "@tanstack/vue-query";

// prime
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import "primeicons/primeicons.css";
import Tooltip from "primevue/tooltip";
import Theme from "./theme";
import { definePreset } from "@primevue/themes";
import Aura from "@primeuix/themes/aura";
import { defaultConfirmOptions } from "@/composables/confirm";
import { ConfirmationEventBus } from "primevue";

// charts
import { Chart, registerables } from "chart.js";
import centerText from "./centerText";

// pinia
import { createPinia } from "pinia";

// js
import App from "./app.vue";

Chart.register(...registerables, centerText);

const app = createApp({});

const CurrentTheme = definePreset(Aura, Theme);

const pinia = createPinia();

app.use(router)
    .use(pinia)
    .use(PrimeVue, {
        theme: {
            preset: CurrentTheme,
            options: {
                cssLayer: {
                    name: "primevue",
                    order: "theme, base, primevue",
                },
            },
        },
    })
    .use(ToastService)
    .use(ConfirmationService)
    .use(autoAnimatePlugin)
    .use(VueQueryPlugin, {
        queryClientConfig: {
            defaultOptions: {
                queries: {
                    staleTime: 10 * 60 * 1000,
                },
            },
        },
        enableDevtoolsV6Plugin: true,
    })
    .directive("tooltip", Tooltip)
    .directive("confirm", {
        mounted(el, { value }) {
            el.addEventListener("click", function () {
                ConfirmationEventBus.emit("confirm", {
                    ...defaultConfirmOptions,
                    ...value,
                });
            });
        },
    })
    .component("app", App);

app.mount("#app");
